<template>

  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="拍卖列表" name="list"></el-tab-pane>
      <el-tab-pane label="拍卖设置" name="setting"></el-tab-pane>
      <el-tab-pane label="求购列表" name="purchase"></el-tab-pane>
    </el-tabs>

    <!--拍卖列表-->
    <List v-if="activeName=='list'"></List>
    <!--求购列表-->
    <Purchase v-if="activeName=='purchase'"></Purchase>
    <!-- 拍卖设置 -->
    <Setting v-if="activeName=='setting'"></Setting>

  </div>
</template>
<script>

  import List from './auction/index';
  import Purchase from './auction/Purchase';
  import Setting from './auction/setting';

  export default {
    components: {
      List,
      Purchase,
      Setting
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        form: {},
        /*参数*/
        param: {},
        /*当前选中*/
        activeName: 'list',
        /*切换数组原始数据*/
        sourceList: [
            {
                key: 'list',
                value: '拍卖列表',
                path:'/plus/auction/index'
            },
            {
                key: 'purchase',
                value: '收购列表',
                path:'/plus/auction/auction/Purchase'
            },
            {
                key: 'setting',
                value: '拍卖设置',
                path:'/plus/auction/auction/setting'
            }

        ],
        /*权限筛选后的数据*/
        tabList:[],
      };
    },
    created() {


    },

    methods: {
    }
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/auction/index.vue